import {
  GET_SCORE_LOADING,
  GET_SCORE_ERROR,
  GET_SCORE_SUCCESS,
  CLEAR_SCORE,
} from "../../../constant/actionTypes";

const initialState = {
  loading: false,
  data: {},
  status: {},
};

const getScoreReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SCORE_LOADING: {
      let obj = { loading: true };
      return obj;
    }
    case GET_SCORE_SUCCESS: {
      let obj = { loading: false, data: action.response };
      return obj;
    }
    case GET_SCORE_ERROR: {
      let obj = { loading: false, status: action.response };
      return obj;
    }
    case CLEAR_SCORE: {
      let obj = { loading: false, data: {}, status: {} };
      return obj;
    }
    default:
      return state;
  }
};

export default getScoreReducer;
